module.exports = __webpack_public_path__ + "img/melitta.49b1e247.png";